import { z } from "zod";

// ---------------------------------------------------------------------------
// Credit note (תעודת זיכוי) — EZcount doc_type 330, AR-only effect
// ---------------------------------------------------------------------------
//
// May be standalone (no linked invoice) or linked to an existing invoice.
// A credit note ONLY reduces the organization's AR balance (organizationBalance).
// It never touches the cash ledger module.

export const CreditNoteSchema = z.object({
	/** = deterministic doc id, derived from idempotencyKey */
	id: z.string().min(1),
	/** EZcount doc_number */
	number: z.string().min(1),
	/** EZcount doc_uuid */
	docUuid: z.string().min(1),
	/** EZcount pdf_link */
	pdfLink: z.string().min(1),
	/** EZcount pdf_link_copy */
	pdfLinkCopy: z.string().optional(),
	organizationId: z.string().min(1),
	billingAccountId: z.string().nullish(),
	/** Set when the credit note is linked to an existing invoice's order */
	orderId: z.string().nullish(),
	invoiceDocUuid: z.string().nullish(),
	invoiceNumber: z.string().nullish(),
	/** Integer agorot (1 ILS = 100 agorot), always positive; gross amount incl. VAT */
	amount: z.number().int().positive(),
	currency: z.literal("ILS"),
	/** Hebrew reason label */
	reason: z.string().min(1),
	note: z.string().nullish(),
	/** Epoch millis */
	creditDate: z.number().int().positive(),
	/** Epoch millis */
	createdAt: z.number().int().positive(),
	/** Admin uid */
	createdBy: z.string().min(1),
	companyId: z.string().min(1),
	storeId: z.string().min(1),
});

export type TCreditNote = z.infer<typeof CreditNoteSchema>;
